<template>
  <div class="modal is-active">
    <div class="modal-background" />

    <div class="modal-card">
      <header
        class="modal-card-head"
        :class="{ 'colorless-head': colorlessHead }"
      >
        <p class="modal-card-title">
          <slot name="title" />
        </p>
        <button
          class="delete"
          aria-label="close"
          @click="close"
        />
      </header>

      <div class="modal-card-body">
        <div
          v-if="messageSuccess"
          class="column"
        >
          <div class="message is-success">
            <div class="message-body">
              <p>{{ messageSuccess }}</p>
            </div>
          </div>
        </div>

        <the-error :message="messageError" />

        <slot name="body" />

        <hr v-if="showButtonContainer">

        <div
          v-if="showButtonContainer"
          :class="{ 'has-tertiary': showBtnTertiary }"
          class="buttons buttons__grid"
        >
          <button
            v-if="showBtnTertiary"
            class="buttons__clean button is-text column"
            style="grid-area:extra"
            @click="click(3)"
          >
            {{ buttonThreeText }}
          </button>

          <button
            v-if="buttonsToShow[0]"
            class="buttons__clean column"
            style="grid-area:left"
            @click="click(2)"
          >
            {{ buttonTwoText }}
          </button>

          <button
            v-if="buttonsToShow[1]"
            :class="{ 'has-primary-btn': buttonsToShow[0] }"
            class="buttons__submit column"
            style="grid-area:right"
            @click="click(1)"
          >
            {{ buttonOneText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  components: {
    TheError: () => import('@/components/TheError.vue'),
  },
  props: {
    messageError: {
      type: [String, Error, Object],
      default: '',
      required: false,
    },
    messageSuccess: {
      type: String,
      default: '',
      required: false,
    },
    showButtons: {
      type: [Boolean, Array],
      default: true,
      required: false,
    },
    showBtnTertiary: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonThreeText: {
      type: String,
      default: 'Button',
      required: false,
    },
    buttonTwoText: {
      type: String,
      default: 'Cancel',
      required: false,
    },
    buttonOneText: {
      type: String,
      default: 'Confirm',
      required: false,
    },
    hasEscape: {
      type: Boolean,
      default: true,
      required: false,
    },
    colorlessHead: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    buttonsToShow() {
      const value = this.showButtons;

      if (typeof this.showButtons === 'boolean') {
        return [value, value];
      }

      return this.showButtons;
    },
    showButtonContainer() {
      return this.buttonsToShow.includes(true);
    },
  },
  created() {
    if (this.hasEscape) window.addEventListener('keydown', this.escape);
  },
  beforeDestroy() {
    if (this.hasEscape) window.removeEventListener('keydown', this.escape);
  },
  methods: {
    escape(event) {
      if (event.key === 'Escape') this.close();
    },
    close() {
      this.$emit('close');
    },
    click(index) {
      this.$emit(`button-${index}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_modal.scss';

.button {
  &.is-text {
    margin: 0 !important;
    min-height: 51px;
    border: none;
  }
}

.colorless-head {
  background-color: #fff;
  border-block-color: rgba(#fff, 0);
  padding-bottom: 0;
}
</style>
